module.exports = __webpack_public_path__ + "media/activity-level/normal-lazy-bones-73041e94.svg";